import { useHotkeys } from '@/lib/useHotkeys';
import { usePlayerStore } from '@/state/playerStore';

/** Playback shortcuts from the design (interactions.md). Page-turner pedals send PageUp/PageDown. */
export function useTransportHotkeys(enabled: boolean): void {
  const { togglePlay, stepBeats, stepBars, toggleLoop, nudgeRate, transpose, setTranspose } =
    usePlayerStore();
  useHotkeys(
    {
      ' ': () => void togglePlay(),
      ArrowLeft: () => {
        stepBeats(-1);
      },
      ArrowRight: () => {
        stepBeats(1);
      },
      'Shift+ArrowLeft': () => {
        stepBars(-1);
      },
      'Shift+ArrowRight': () => {
        stepBars(1);
      },
      PageUp: () => {
        stepBars(-1);
      },
      PageDown: () => {
        stepBars(1);
      },
      l: toggleLoop,
      '-': () => {
        nudgeRate(-1);
      },
      '+': () => {
        nudgeRate(1);
      },
      '=': () => {
        nudgeRate(1);
      },
      '[': () => {
        setTranspose(transpose - 1);
      },
      ']': () => {
        setTranspose(transpose + 1);
      },
    },
    enabled,
  );
}
